import axios from "axios";

axios.defaults.withCredentials = true;

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const CONTACT_FALLBACK = "contacto@threebu.mx";

export async function getMe() {
  const { data } = await axios.get(`${API}/auth/me`);
  return data;
}
export async function postSession(sessionId) {
  const { data } = await axios.post(`${API}/auth/session`, {}, { headers: { "X-Session-ID": sessionId } });
  return data;
}
export async function logoutApi() {
  await axios.post(`${API}/auth/logout`, {});
}
export async function adminListEmails() {
  const { data } = await axios.get(`${API}/admin/emails`);
  return data;
}
export async function adminAddEmail(email) {
  const { data } = await axios.post(`${API}/admin/emails`, { email });
  return data;
}
export async function adminRemoveEmail(email) {
  const { data } = await axios.delete(`${API}/admin/emails/${encodeURIComponent(email)}`);
  return data;
}

export const COLORS = {
  actividades: "#C17A5A",
  rac: "#C03C54",
  guinda: "#C03C54",
  guindaDark: "#A52F43",
  terracota: "#C17A5A",
  terracotaDark: "#A5613F",
  areas: "#C99A2E",
  areasStroke: "#A87A1E",
  colonias: "#6B8E23",
  coloniasStroke: "#556B14",
  activaciones: "#5A524A",
};

export const POLY_LAYER_LABELS = {
  secciones: "Secciones",
  areas: "Áreas",
  colonias: "Colonias",
};

export async function fetchAreasGeojson() {
  const { data } = await axios.get(`${API}/geojson/areas`);
  return data;
}

export async function fetchColoniasGeojson() {
  const { data } = await axios.get(`${API}/geojson/colonias`);
  return data;
}

export async function fetchMapConfig() {
  const { data } = await axios.get(`${API}/map/config`);
  return data;
}

export async function adminGetMapConfig() {
  const { data } = await axios.get(`${API}/admin/map-config`);
  return data;
}

export async function adminUpdateMapConfig(cfg) {
  const { data } = await axios.put(`${API}/admin/map-config`, cfg);
  return data;
}

export const LEVEL_OF = { secciones: "seccion", areas: "area", colonias: "colonia" };
export const LEVEL_TO_LAYER = { seccion: "secciones", area: "areas", colonia: "colonias" };
export const LEVEL_SINGULAR = { seccion: "Sección", area: "Área", colonia: "Colonia" };
export const LEVEL_ARTICLE = { seccion: "de la Sección", area: "del Área", colonia: "de la Colonia" };

export const LAYER_LABELS = {
  actividades: "Obras y Actividades",
  rac: "Reportes Ciudadanos",
};

export async function fetchFilters() {
  const { data } = await axios.get(`${API}/filters`);
  return data;
}

export async function fetchPoints(params) {
  const { data } = await axios.get(`${API}/points`, { params });
  return data;
}

export async function fetchSections() {
  const { data } = await axios.get(`${API}/sections`);
  return data;
}

export async function fetchGeojson() {
  const { data } = await axios.get(`${API}/geojson`);
  return data;
}

export async function fetchCseccion() {
  const { data } = await axios.get(`${API}/cseccion`);
  return data;
}

export async function resolveSearch(q) {
  const { data } = await axios.get(`${API}/search/resolve`, { params: { q } });
  return data;
}

export async function fetchSummary(level, value, search) {
  const params = {};
  if (level) params.level = level;
  if (value) params.value = value;
  if (search) params.search = search;
  const { data } = await axios.get(`${API}/summary`, { params });
  return data;
}

export async function fetchMeta() {
  const { data } = await axios.get(`${API}/meta`);
  return data;
}

export async function triggerSync() {
  const { data } = await axios.post(`${API}/sync`);
  return data;
}

export function reportUrl(level, value) {
  return `${API}/report?level=${encodeURIComponent(level)}&value=${encodeURIComponent(value)}`;
}

export function exportUrl(level, value) {
  return `${API}/export?level=${encodeURIComponent(level)}&value=${encodeURIComponent(value)}`;
}
